import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: var(--footer-bg);
  color: var(--footer-text);
  padding: 2rem 0;
  width: 100%;
`;

const FooterContent = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FooterLogo = styled(Link)`
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--footer-text);
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  
  &:hover {
    text-decoration: none;
    opacity: 0.8;
  }
`;

const Copyright = styled.div`
  color: var(--footer-text);
  opacity: 0.8;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo to="/">BehindScams</FooterLogo>
        <Copyright>
          <div>All content copyright behindscams © 2025 • All rights reserved.</div>
          <div>Report: behindscams@proton.me</div>
          <div>Non-profit</div>
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 